<template>
    <div class="myBooking">
        <hua-form :label-width="120" :input-align="'left'">
            <hua-field type="number" v-model="phoneNumber" placeholder="请输入手机号" />
            <hua-field v-model="validateCode" center placeholder="请输入验证码">
                <template #button>
                    <span id="code"></span>
                </template>
            </hua-field>
        </hua-form>
        <!-- <span class="tipText">请输入您历史预约使用的手机号进行查询</span> -->
        <div class="v-search-btn">
            <hua-button type="primary" block round @click.prevent="onSearch">查 询</hua-button>
            <div class="tip-text">
                <img class="tip-icon" src="@/image/fkyy_pic_note.png" alt="">
                【温馨提示】请输入您历史预约使用的手机号进行查询。
            </div>
        </div>
    </div>
</template>

<script>
import rexp from '@/constants/rexp'
import api from '@/constants/api'

export default {
    mounted() {
        this.realCode = this.createCode(4)
    },
    data() {
        return {
            phoneNumber: '',
            validateCode: '',
            realCode: '',
            rexp,
        }
    },
    methods: {
        createCode(num) {
            let codeArr = '1234567890',
                codeBox = document.getElementById('code'),
                code = '',
                color = '#',
                colorArr = '0123456789abcdef',
                realCode = ''
            for (let i = 0; i < num; i++) {
                for (let k = 0; k < 6; k++) {
                    let colorIndex = Math.floor(Math.random() * colorArr.length)
                    color += colorArr[colorIndex]
                }
                let index = Math.floor(Math.random() * codeArr.length)
                code +=
                    "<em style='color:" +
                    color +
                    ";font-weight:bold;display:inline-block;margin-left:5px;font-size:18px'>" +
                    codeArr[index] +
                    '</em>'
                color = '#'
                realCode += codeArr[index]
            }
            codeBox.innerHTML = code
            return realCode
        },

        onSearch() {
            if (!this.phoneNumber) {
                return this.$toast('请输入手机号')
            } else if (!rexp.phone.test(this.phoneNumber)) {
                return this.$toast('手机号格式不正确')
            }
            if (!this.validateCode) {
                return this.$toast('请输入验证码')
            } else if (this.validateCode !== this.realCode) {
                this.$toast('验证码错误')
                this.realCode = this.createCode(4)
                return
            }
            let params = {
                phoneNum: this.phoneNumber,
                pageNum: 1,
                pageSize: 1000,
            }
            api.myAppointmentInfo(params).then((res) => {
                let data = res.data.pageData
                if (data.length) {
                    this.$emit('onSearch', data)
                } else {
                    this.$toast.fail('无历史记录')
                }
            })
        },
    },
}
</script>

<style lang="less">
.myBooking {
    margin: 15px 0;
    .tipText {
        display: block;
        color: #b0b0b0;
        margin: 15px 15px 20px;
    }
    .v-search-btn {
        margin: 0 15px;
        margin-top: 10px;
        .tip-text {
            padding: 10px 15px;
            display: flex;
            align-items: flex-start;
            color: #ff7e0b;
            .tip-icon {
                margin-top: 1px;
                width: 14px;
            }
        }
    }
}
</style>